import { Dictionary } from "vue-router/types/router";
import router from "../router";

// create query params and redirect to 'WorkMate' page
export function pushCoords(
  destination?: string | null,
  origin?: string | null,
  assetOnly?: boolean | null,
  noti?: string | null,
  workOrder?: string | null
): void {
  const query: Dictionary<string> = {};
  if (destination) {
    query.destination = destination;
  } else if (noti) {
    query.noti = noti;
  } else if (workOrder) {
    query["work_order"] = workOrder;
  }
  if (origin) {
    query.origin = origin;
  } else if (assetOnly) {
    query.assetOnly = "true";
  }
  router.push({
    name: "WorkMate",
    query: query
  });
}
